module.exports = __webpack_public_path__ + "static/media/Argos - User Unassigned - Purple.84fe650d.svg";